import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { scheduleEventsApi } from "./scheduleEventsApi";

export const useScheduleEvents = (courseId: string | number) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.SCHEDULE_EVENTS(courseId),
    queryFn: () => scheduleEventsApi.fetchByCourseId(Number(courseId)),
    placeholderData: keepPreviousData,
    enabled: !!courseId && !isNaN(Number(courseId)),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.SCHEDULE_EVENTS(courseId),
    });
  };

  return { invalidate, isLoading, isFetching, schedule: data?.data };
};
